/**
 * Shared palette for trend-direction visual cues (KPI sparklines, tiles,
 * pulse indicators). Up = positive trend, down = negative, flat = neutral.
 *
 * Values are semantic CSS color tokens because they feed into Highcharts
 * series colors and inline SVG attributes that cannot use Tailwind classes.
 *
 * Consumers: KpiCard.vue, KpiTile.vue, PulseTile.vue.
 */

const TREND_UP_COLOR = 'rgb(var(--color-state-success))';
const TREND_DOWN_COLOR = 'rgb(var(--color-state-danger))';

const TREND_NEUTRAL_LIGHT = 'rgb(var(--color-text-muted))';
const TREND_NEUTRAL = 'rgb(var(--color-text-muted))';

/**
 * Resolve a sparkline color from a trend direction string.
 * @param {'up' | 'down' | string | null | undefined} direction
 * @param {{ neutralVariant?: 'light' | 'default' }} [opts]
 * @returns {string} CSS color
 */
export function getTrendDirectionColor(direction, { neutralVariant = 'default' } = {}) {
  if (direction === 'up') return TREND_UP_COLOR;
  if (direction === 'down') return TREND_DOWN_COLOR;
  return neutralVariant === 'light' ? TREND_NEUTRAL_LIGHT : TREND_NEUTRAL;
}

export {
  TREND_DOWN_COLOR,
  TREND_NEUTRAL,
  TREND_NEUTRAL_LIGHT,
  TREND_UP_COLOR
};
